<template>
    <div class="addAddress">
        <!-- 头部 -->
        <div class="header">
            <div class="header-left" @click="back">
            <span class="iconfont iconzuojiantou"></span>
            </div>
            <div class="header-center">
            <p>添加地址</p>
            </div>
            <div class="header-rigth">
            
            </div>
        </div>
        <!-- 地址栏 -->
        <div class="addressOut">
            <!-- <van-cell-group> -->
                <div class="formItem"><van-field v-model="name"  label="收货人" placeholder="请输入您的姓名" required/></div>
                <div class="formItem"><van-field v-model="phone"  label="联系方式" placeholder="请输入您的手机号码" type="number" required/></div>
                <div class="formItem" @click="focus"><van-field v-model="citiy"  label="所在地区" placeholder="请选择您的所在地区" readonly required/></div>
                <div class="formItem"><van-field v-model="tAddress"  label="详细地址" placeholder="请输入您的详细地址" required/></div>
                <div class="formItem"><van-field v-model="room"  label="房屋面积（㎡）" placeholder="请输入您的房屋面积" type="number"/></div>
                <div class="formItem"><van-checkbox v-model="checked" checked-color="#07c160">设置为默认地址</van-checkbox></div>
            <!-- </van-cell-group> -->
        </div>
        <!-- 按钮 -->
        <div class="button">
            <van-button size="large" class="confirm" @click="confirm">确认</van-button>          
            <van-button size="large" class="back" @click="back">返回</van-button>
        </div>
        <!-- 选择地址 -->
        <van-popup v-model="isShowArea" position="bottom" :overlay="true">
                  <van-area :area-list="areaList" value="441900" @cancel="onCancel" @confirm="onConfirm"/>
         </van-popup>
    </div>
</template>

<script>
import areaList from '../../assets/Area/area.js'
import { Dialog,Toast } from 'vant'
export default {
    data () {
        return {
        areaList: areaList,
        isShowArea:false,
        name:'',
        phone: '',
        citiy: '',
        address0: '',
        address1: '',
        address2: '',
        tAddress: '',
        room: '',
        checked: false,
        defaultAddress: 0
        }
    },
    computed:{
       
    },
    created () {
  
        
    },
    methods: {
        back () {
             this.$router.back()
        },
        focus () {
            this.isShowArea = true
        },
        onCancel () {
            this.isShowArea = false
        },
        onConfirm (value,index) {
            this.address0 = value[0].name
            this.address1 = value[1].name
            this.address2 = value[2].name
            this.citiy = this.address0+','+this.address1+','+this.address2
            this.isShowArea = false
            
        },
        confirm () {
            if (this.name=='' || this.phone=='' || this.citiy=='' || this.tAddress=='') {
                   Toast.fail('资料不完整');
            }else{

                Dialog.confirm({
                title: '添加新地址',
                message: '确定要添加新地址吗？'
                }).then(() => {
                this.$axios.post('/api/DjAddress/Save',{
                    guestName:this.name,
                    guestPhone:this.phone,
                    guestAddress:this.address0+this.address1+this.address2+this.tAddress,
                    address0:this.address0,
                    address1:this.address1,
                    address2:this.address2,
                    tAddress:this.tAddress,
                    defaultAddress:this.defaultAddress,
                    Acreage:this.room
                }).then((res)=>{
                    if(res.data.type == 1){
                        Toast.success('添加成功');
                        this.$router.back()
                    }else{
                        Toast.fail('操作失败！');
                    }
                })
            
                
                }).catch(() => {
                
                });

            }



            
            
        }
        
    },
    watch: {
        checked (value) {
           if (value) {
             this.defaultAddress = 1
           }else{
               this.defaultAddress = 0
           }
        }
    }
    
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.addAddress
  .header
    position: fixed
    z-index: 90
    left: 0
    right: 0
    top: 0
    display: flex
    justify-content: space-between
    width: 100%
    height: 40px
    align-items: center
    background-color: white
    font-weight: bold
    .header-left
     padding-left: 8px
     height: 100%
     width: 40px
     display: flex
     align-items: center
   .header-center
     font-size: 20px
     width: 120px
  .addressOut
    width: 100%
    margin-top: 56px
    >>> .van-field__label
      max-width: 110px
    >>>.van-checkbox
       display: flex
       align-items: center
       height: 44px
       padding-left: 12px
  .button
    width: 100%
    margin-top: 10px
    display: flex
    flex-direction: column
    align-items: center
    .confirm
      width: 90%
      margin-bottom: 10px
      color: white
      background: #009933
      border-radius: 6px
      font-size: 18px
    .back
      width: 90%
      margin-bottom: 10px
      color: white
      background: #009933
      border-radius: 6px
      font-size: 18px
.addressOut
  width 100%
  & .formItem
    border-bottom 1px solid #eeeeee
</style>



// WEBPACK FOOTER //
// src/pages/Address/AddAddress.vue